<template>
  <a-card :bordered="false">
    <div class="table-operator">
      <a-button type="primary" @click="handleAdd" icon="plus">新建</a-button>
    </div>
    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
    >
      <template slot="action" slot-scope="text, record">
        <div class='editable-row-operations'>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
            <a @click="del(record)">删除</a>
        </div>
      </template>
    </s-table>

    <a-modal
      :title="modal_title"
      :width="800"
      v-model="visible"
      okText='提交'
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :autoFormCreate="(form)=>{this.form = form}">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='分类名称'
          fieldDecoratorId="name"
          :fieldDecoratorOptions="{
            rules: [{ required: true, message: '请填写分类名称' }],
            initialValue: mdl.name,
          }"
        >
          <a-input placeholder='分类名称' />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label='描述'
          fieldDecoratorId="description"
          :fieldDecoratorOptions="{
            initialValue: mdl.description,
          }"
        >
          <a-input placeholder='描述' />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>
<script>
import STable from '@/components/table/'
import { getCategoryList, updateCategory, deleteCategory } from '@/api/category'
import { getQiniuToken } from '@/api/qiniu'

export default {
  name: 'Category',
  components: {
    STable
  },
  data() {
    return {
      visible: false,
      modal_title: '添加分类',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      mdl: {},
      imgForm: {},
      bucketHost: '',
      loading: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '分类ID',
          dataIndex: 'id'
        },
        {
          title: '分类名称',
          dataIndex: 'name',
        },
        {
          title: '分类描述',
          dataIndex: 'description',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: params => {
        return getCategoryList(Object.assign(params, this.queryParam)).then(res => res)
      },
    }
  },
  methods: {
    handleAdd () {
      this.mdl = {}
      this.visible = true
    },
    handleEdit (record) {
      this.modal_title = '修改分类'
      this.mdl = Object.assign({}, record)
      this.visible = true
    },
    handleOk () {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.mdl = Object.assign(this.mdl, values)
          updateCategory( this.mdl).then(res => {
            this.$refs.table.refresh();
            this.$message.success(this.mdl.id?'修改成功过':'添加成功');
            this.form.resetFields();
            this.visible = false;
          })
        }
      })
    },
    // eslint-disable-next-line
    del (row) {
      const _this = this
      this.$confirm({
        title: '警告',
        content: '真的要删除吗?',
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          deleteCategory(row.id).then(res => {
             _this.$refs.table.refresh()
              _this.$message.success('删除成功')
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    handleCancel () {
      this.form.resetFields();
      this.visible = false
    },
    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.loading = true
      } else if (info.file.status === 'done') {
        let key = info.file.response.key
        this.mdl.pic_url = `${this.bucketHost}${key}`
        this.loading = false
      } else if (info.file.status === 'error') {
        this.loading = false
        this.$message.error('上传图片失败，请重试')
      }
    },
    beforeUpload: function () {
      let _this = this
      return getQiniuToken().then(res => {
        _this.bucketHost = res.data.bucketHost
        _this.imgForm = {
          // key: res.key,
          token: res.data.token
        }
      })
    }
  }
}
</script>
